import { EventsName } from '@space-lib-events/constants'

import type { ProductFruitsUserEvent } from './types'

export const setProductFruitsUserEventDispatch = (payload: ProductFruitsUserEvent) =>
  window.dispatchEvent(new CustomEvent(EventsName.PRODUCT_FRUITS_USER, { detail: payload }))

export const setProductFruitsUserEventListener = (listener: (event: Event) => void) => {
  window.addEventListener(EventsName.PRODUCT_FRUITS_USER, listener)

  return () => window.removeEventListener(EventsName.PRODUCT_FRUITS_USER, listener)
}
